import React, {useContext, createContext} from "react";

const AuthContext = createContext({});
export default AuthContext
export const useAuth = () => useContext(AuthContext);
